
<div class="view-component">
    <div class="view-component-title">
        <span class="title">Integração de Pagamentos</span>
    </div>
    <div class="content">
        <div class="tabcontent">
            <nz-tabs class="custom-tabs" (nzSelectChange)="onTabChanged('Mktppayments')">
                <nz-tab [nzTitle]="'payments.tab.details'|translateTA">
                    <div class="mktplace">
                        <simple-datagrid entityName="Mktppayments" [parentRow]="parentRow" condition="0=0" [events]="eventsSubject.asObservable()"></simple-datagrid>
                    </div>
                </nz-tab>
            </nz-tabs>
        </div>
    </div>
</div> 